const RECIPE_SEARCH_ROUTE_IDS = new Set([
  'recipe-designer',
  'recipe-results',
]);

export const hasPinnedRecipeResult = (pinnedRouteIds = []) => (
  pinnedRouteIds.some((pinId) => (
    typeof pinId === 'string' && pinId.startsWith('recipe-results/')
  ))
);

export const shouldLoadRecipeNavigationData = (drawerOpen, pinnedRouteIds = []) => (
  Boolean(drawerOpen || hasPinnedRecipeResult(pinnedRouteIds))
);

export const buildNavigationSearchDatasets = (
  visibleRoutes = [],
  pinnedItems = []
) => {
  const candidates = [
    ...visibleRoutes.filter((route) => (
      !route?.isPermanent || RECIPE_SEARCH_ROUTE_IDS.has(route.id)
    )),
    ...pinnedItems.filter((item) => item?.type === 'recipe-pin'),
  ];
  const seenIds = new Set();

  return candidates.filter((item) => {
    if (!item?.id || seenIds.has(item.id)) return false;
    seenIds.add(item.id);
    return true;
  });
};

export default {
  hasPinnedRecipeResult,
  shouldLoadRecipeNavigationData,
  buildNavigationSearchDatasets,
};
